<template>
  <div>
    <div id="chart-container" class="by-need">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-functional-need-e-chart" class="chart-row">
        <profile-chart-header
            :title="'Value Profile | ' + titleSuffix"
            :display="this.$parent.getDisplayView() && getDisplayView()"
            :input-display-number-of-responses="eChartCriteria.displayNumberOfResponses"
            :input-show-tooltip="eChartCriteria.showTooltip"
            :display-sort-by="true"            
            :input-sort-by-options="sort_by_options"
            :input-sort-by="orderByValue"
            :display-download-comments="true"
            :content-list="contentList"
            :content-name="'Value Profile'"
            @set-sort-by="setSortBy"
            @set-display-number-of-responses="setDisplayNumberOfResponses"
            @set-show-tooltip="setShowTooltip"

        />
        <profile-chart ref="eChart"
            :e-chart-mini-id="'profile-chart-mini'"
            :e-chart-id="'profile-chart'"
            :input-report-type-name="'Chart - Needs Profile'"
            :modal-id="'functional-needs-chart'"
            :is-saved-card="$parent.clientChart.clientChartId != 0" 
            :input-client-chart="this.$parent.clientChart"
            :inputDownloadFileName="'Value Profile - ' + titleSuffix"
            @save-table="saveProfileDataTable"
            @save-criteria="buildClientChart"/>        
      </div>      
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="functionalTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
          <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 50%"/>
        </div>
        <chart-data-table
          ref="functionalDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.functionalTable.data"
          :is-saved-card="$parent.clientChart.clientChartId != 0"           
          :display-direction="'vertical'"
          :data-container-id="functionalTable.tableContainerId"
          :container-id="'functional_needs_chart'"
          :column-defs="this.chart.columnDefsFunctional"
          :table-class="'table display row-border table-hover'"
          :table-width="'auto'"
          :table-title="this.functionalTable.title"
          :report-page-type-name="'Table - Functional Needs'"
          :insight-modal-id="'functional-needs-table'"
          :content-list="this.contentList"
          :inputDownloadFileName="'Value Profile - ' + titleSuffix"
          :effort-list="functionalEffortList"
          :use-alternate-title="true"
          :display-profile-strength-legend="$parent.displayProfileStrengthLegend"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        ></chart-data-table>
      </div>
    </div>
    
    <insights
      ref="insightsFunctionalChart"
      :modal-name="'functional-needs-chart'"
      :report-page-type-name="'Chart - Needs Profile'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsFunctionalTable"
      :modal-name="'functional-needs-table'"
      :report-page-type-name="'Table - Functional Needs'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsEmotionalTable"
      :modal-name="'emotional-needs-table'"
      :report-page-type-name="'Table - Emotional Needs'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChart from "../../../views/echarts/ProfileChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ProfileService from "../../../services/echarts/profile.service";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import SurveyService from "../../../services/survey.service";
export default {
  name: "ByNeed",
  mixins: [ChartCompanyMixins],
  components: {ProfileChart, ProfileChartHeader},
  data() {
    return {
      displayType: "need",
      orderByValue: "expectations",
      functionalEffortList: [],
      sort_by_options: [],
      functionalTable: {
        id: "",
        tableContainerId: "functional_needs_data_container",
        data: {},
        title: ""
      },
      isMobile: false,
      pricingPowerColumn: 0,
      functionalDrivers: ChartService.getDefaultFunctionalDrivers(),
      emotionalDrivers: ChartService.getDefaultEmotionalDrivers(),
      titleSuffix: "",
    };
  },
  props: {
     verbatimsData: {
      type: Array,
      default: function() {
        return [];
      }    
   },
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    },
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    
  },
  mounted() {
    $.extend(this.$refs.functionalDataTable.configuration, { orderFixed: [[0, "asc"]] });
    this.buildSortByOptions();      
  },
  created() {},
  methods: {
    buildSortByOptions() {
      this.sort_by_options = [];
      this.sort_by_options.push({ name: "Expectations", value: "expectations" });
      this.sort_by_options.push({ name: SurveyService.getWTPLabel(), value: "willingnessToPay" });
      this.sort_by_options.push({ name: "Value Gap", value: "value-gap" });
      this.sort_by_options.push({ name: "Satisfaction", value: "satisfaction" });
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Needs Profile") {
        this.$refs.insightsFunctionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Functional Needs") {
        this.$refs.insightsFunctionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async processChartData() {
      try {
        this.chart = ChartService.getChartAttributes("Profile");
        for (let i = 0; i < this.chartData.length; i++) {
          let needsData = JSON.parse(JSON.stringify(this.chartData[i]));
          let otherData = needsData["otherData"];
          
          let needsList = otherData["needsList"];
          let companyColorList = otherData["companyColorList"];
          TableService.setCompanyColorList(companyColorList);

          let containerId = needsData["containerId"];

          this.table.id = containerId;
          let chartContainerWidth = $("#chart-container").width();
          if (chartContainerWidth < ChartService.getMobileBreakpoint()) {
            this.isMobile = true;
          } else {
            this.isMobile = false;
          }
          let dataLengthMax = 100;
          if (containerId === "functional_needs_chart") {
            this.functionalEffortList = otherData["effortList"];
            let breakPointList = otherData["breakPointList"];
            this.$parent.selectedValueRoadMapId = otherData["selectedValueRoadMapId"];
            let titleSuffix = otherData["titleSuffix"];
            if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
              this.titleSuffix = titleSuffix;
            }
            ChartService.setVerticalLineBreakPoints(breakPointList);
            dataLengthMax = this.isMobile ? 12 : 100;
            NeedsService.setFunctionalNeedsList(needsList);
            this.functionalTable.id = containerId;
            needsData.rows = otherData["finalRows"];
            this.$parent.setChartResults(needsData.companyList);
            this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
            
            let showRelationshipStrength = this.$parent.$data.criteriaResultsList.find(item => item.name === "Show Relative Strength");
            if (typeof showRelationshipStrength != "undefined" && showRelationshipStrength.displayValue == "Yes") {
              this.$parent.displayProfileStrengthLegend = true;
            } else {
              this.$parent.displayProfileStrengthLegend = false;
            }

            let labelIndex = 1;
            let copyOfChartData = JSON.parse(JSON.stringify(needsData));
            for (let indexRows = 0; indexRows < needsData.rows.length; indexRows++) {
              let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
              let originalName = copyOfChartDataRow[labelIndex].v;
              if (originalName != null && originalName.includes(",")) {
                let copyValue = copyOfChartDataRow[labelIndex].v.split(",");
                if (typeof copyValue != "undefined") {
                  if (indexRows <= 4 ) {
                    this.setEmotionDriverName(copyValue[0], indexRows);
                  }
                  copyOfChartDataRow[labelIndex].v = copyValue[0];
                  if (typeof copyValue[1] != "undefined") {
                    copyOfChartDataRow[labelIndex].v.trim();
                    copyOfChartDataRow[labelIndex].v += " / " + copyValue[1];
                    NeedsService.replaceNeedName(originalName, copyOfChartDataRow[labelIndex].v, "emotional");
                  }
                }
              }
            }
            let columns = needsData["cols"];
            this.pricingPowerColumn = columns.findIndex(col => col.id === "pricing-power");
            let isPositiveCorrelation = otherData["isPositiveCorrelation"];
            this.chart.columnDefsFunctional = this.buildColumns(columns,isPositiveCorrelation);
            this.functionalTable.data = JSON.parse(JSON.stringify(copyOfChartData));
            for (let indexColumns = 0; indexColumns < needsData.cols.length; indexColumns++) {
              let label = needsData.cols[indexColumns]["label"];
              label = label.length > dataLengthMax ? label.substr(0, dataLengthMax) + "…" : label;
              needsData.cols[indexColumns]["label"] = label;
            }
          } else if (containerId === "emotional_needs_chart") {
            let emotionalNeedsList = otherData["effortList"];
            this.functionalEffortList = this.functionalEffortList.concat(emotionalNeedsList);
            NeedsService.setEmotionalNeedsList(needsList);
            this.$parent.valueMapData.data = otherData["needsMapList"];
            this.$parent.valueMapData.title = this.$parent.survey.name + " Needs Map";
          }
        }
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
        this.setEChartCriteria(this.$parent.$refs.chartCriteria.eChartCriteria);
        this.parseProfileDataForNeed(JSON.parse(JSON.stringify(this.chartData)));
        this.eChartCriteria.eChartType = "stacked-bar-vertical";
        this.sortData();
        this.processVerbatimsData();
        this.$refs.eChart.processChart(true,"need",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
        $("#cp-by-functional-need-e-chart").addClass("chart-wrapper");
      } catch (err) {
        ErrorService.processException("ByNeed.displayChartCallback", err, "chart", this);
      }
    },
    buildColumns(columns,isPositiveCorrelation = true){
      let returnColumns = [];
      returnColumns.push(TableService.getOrderSequence());
      returnColumns.push({ targets: [0], visible: false });
      returnColumns.push(TableService.getFunctionalNeedNameTableAttribute([1]));
      returnColumns.push(TableService.getNumericTableAttribute([2], "dt-right", 50));
      returnColumns.push(TableService.getNumericTableAttribute([3], "dt-right", 50));
      returnColumns.push(TableService.getNumericTableAttribute([4], "dt-right", 50));
      let position = 0;
      columns.forEach(function(column) {
        if (position >= 5){
          if (column.id == "pricing-power"){
            returnColumns.push(TableService.getPercentTableAttribute([position], "dt-right", 50, 2)); // Pricing Power
          } else if (column.label == "Relative Strength"){
            returnColumns.push(TableService.getRelativeStrengthTableAttribute([position], "dt-right", 50, 2,isPositiveCorrelation)); // Relative Strength
          } else if (column.label == "Metric" || column.label == "Growth Ideas" || column.label == "Road Map Initiatives"){ 
            returnColumns.push(TableService.getMetricTableAttribute([position], "dt-left", 200, 2));
          } else {
            returnColumns.push(TableService.getNumericTableAttribute([position], "dt-right", 50));
          }
        }
        position++;
      });
      returnColumns.push(TableService.getNumericTableAttribute(["_all"], "dt-right", 50));
      return returnColumns;
    },
    setSortBy: function(value) {
      if (value != ""){
        this.orderByValue = value;
        this.$parent.$refs.chartCriteria.eChartCriteria.sortBy = value;
        this.sortData();
        this.processVerbatimsData();
        this.$refs.eChart.processChart(true,"need",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
      }
    },
    sortData:function() {
        let columnIndex = 2;
        let chart1Data = this.eChartData.chart1.data;
        let chart2Data = this.eChartData.chart2.data;
        if (this.orderByValue == "willingnessToPay") {
          columnIndex = this.pricingPowerColumn - 1;
        } else if (this.orderByValue == "satisfaction") {
          columnIndex = 3;
        } else if (this.orderByValue == "expectations") {
          columnIndex = 2;
        } else if (this.orderByValue == "value-gap") {
          columnIndex = 1;
        }
        this.sortDataByColumn(columnIndex, chart1Data, chart2Data);
    },
    sortDataByColumn: function(columnIndex,chart1Data, chart2Data) {
      let useAbsoluteValue = false;
      chart1Data.sort((a, b) => {
        let aValue = parseFloat(a[columnIndex]);
        let bValue = parseFloat(b[columnIndex]);
        if (isNaN(aValue)) {
          aValue =  0; 
        }
        if (isNaN(bValue)) {
          bValue = 0; 
        }
        if (useAbsoluteValue) {
          aValue = Math.abs(aValue);
          bValue = Math.abs(bValue);
        }
        return bValue - aValue; // descending 
      });
      useAbsoluteValue = this.orderByValue == "value-gap";
      this.eChartData.chart1.data = JSON.parse(JSON.stringify(chart1Data));
      chart2Data.sort((a, b) => {
        let aValue = parseFloat(a[columnIndex]);
        let bValue = parseFloat(b[columnIndex]);
        if (isNaN(aValue)) {
          aValue =  0; 
        }
        if (isNaN(bValue)) {
          bValue = 0; 
        }
        if (useAbsoluteValue) {
          aValue = Math.abs(aValue);
          bValue = Math.abs(bValue);
        }
        return bValue - aValue; // descending 
      });
      // create function to reverse the order of the data if the orderByValue is "value-gap"
      if (this.orderByValue == "value-gap") {
        this.eChartData.chart1.data.reverse();
        this.eChartData.chart2.data.reverse();
      }
      this.eChartData.chart2.data = JSON.parse(JSON.stringify(chart2Data));
    },
    parseProfileDataForNeed: function(inputData){
      let data = {};
      // Functional Needs
      let chart1Data = inputData[0];
      let itemsToRemove = chart1Data["otherData"]["itemsToRemove"];
      // Emotional Needs
      let chart2Data = inputData[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(inputData[0],data);
      this.eChartData = JSON.parse(JSON.stringify(data));
    }, 
    processVerbatimsData: function(){
      if (!$.isEmptyObject(this.verbatimsData)) {
        this.eChartData.verbatims = (JSON.parse(JSON.stringify(this.verbatimsData))); 
        if (this.chartData.length == 0) {
          return;
        }
        this.$refs.eChart.processChart(true,"need",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
      }
    },
    async saveProfileDataTable() {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        const vm = this;
        setTimeout(function() {    
          ReportService.saveReportTableFile(vm.$refs.functionalDataTable.getTableData(), "Table - Functional Needs", vm.$parent.clientChart, vm.saveReportTableFileCallback, vm);
          ReportService.saveReportPage(vm.getReportTableContent("functional_needs_chart"), "Table - Functional Needs", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
          ReportService.saveReportPage(vm.getReportTableContent("emotional_needs_chart"), "Table - Emotional Needs", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
        }, 1500);        
      }
    },
    saveAllReportPages() {
      this.saveProfileDataTable();
    },
  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChart.clear();} catch(e){}
      this.buildSortByOptions();      
    },
    verbatimsData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "need") {
        this.processVerbatimsData();
      } 
    },
    chartData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "need") {
        if (typeof this.$parent.$refs.chartCriteria.eChartCriteria != "undefined" && typeof this.$parent.$refs.chartCriteria.eChartCriteria.sortBy != "undefined") {
          this.orderByValue = this.$parent.$refs.chartCriteria.eChartCriteria.sortBy;
          this.eChartCriteria.sortBy = this.$parent.$refs.chartCriteria.eChartCriteria.sortBy;
        }        
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
